import { useState } from "react";
import {FaApple} from "react-icons/fa6";

function Navbar({isHomePage}) {
    const [open, setOpen] = useState(false);

    return (
        <nav className="nav">
            <div className="logo">
                <a href="/" style={{textDecoration: "none", color: "inherit"}}>ina<span>read</span></a>
            </div>

            {/* Hamburger */}

            <>
                <div className="menu-toggle" onClick={() => setOpen(!open)}>
                    ☰
                </div>

                {/* Menu */}
                <div className={`nav-menu ${open ? "open" : ""}`}>

                    <ul>
                        {isHomePage && ( <li><a href="#features">Features</a></li>)}
                        <li><a href="/contact">Contact Us</a></li>
                        <li><a href="/privacy-policy">Privacy policy</a></li>
                    </ul>

                    {isHomePage && (
                        <div className="nav-dl">
                            <a href="#download" className="dl-btn">
                                <FaApple style={{size: "lg", color: "inherit"}}/>
                                <span>App Store</span>
                            </a>

                            <a href="#download" className="dl-btn">
                                <span>▶</span>
                                <span>Google Play</span>
                            </a>
                        </div>
                    )}
                </div>
            </>

        </nav>
    );
}

export default Navbar;
